import api from "@/services/api";

const { get } = api.getPrefixedMethods("monitoring");
const { get: optumGet } = api.getPrefixedMethods("optum");

export const monitoringServices = {
  /**
   * Get metrics for the monitoring dashboard
   * @param {number} hours - Number of hours to look back (default: 24)
   * @returns {Promise} Metrics data including uptime, requests, response times
   */
  getMetrics(hours = 24) {
    return get(`metrics`, { params: { hours: hours } });
  },

  /**
   * Call the external health check endpoint
   * @returns {Promise} Health status
   */
  healthCheck() {
    return optumGet(`v1/health`, { _noAuthHeader: true });
  },
};
